export const isDevelopment = import.meta.env.MODE === 'development';
// Toggles OnePortal related UI changes. Enabled for local dev and integ, disabled for lab/staging/prod.
export const FEATURE_ONEPORTAL = import.meta.env.VITE_FEATURE_ONEPORTAL === 'true';
export const APP_VERSION = __APP_VERSION__;
export const PROBONIO_IMPRINT = 'https://www.probonio.de/impressum';
export const PROBONIO_FAQ = 'https://probonio.de/faq';
export const BIKELEASING_FAQ = 'https://bikeleasing.de/faq';
export const BIKELEASING_FAQ_EN = 'https://bikeleasing.de/en/faq';
export const BIKELEASING_HOW_TO_DIENSTRAD = 'https://www.youtube.com/watch?v=PLy7WGVNcFg';
export const BIKELEASING_PIM_URL = import.meta.env.VITE_BIKELEASING_PIM_URL;
export const BIKELEASING_PRESELECTED_ROLE = 'ROLE_EMPLOYEE';
